// М1 — надпис над група редове в секцията на ползвателя.
//
// Причината: на страницата на ползвателя стоят една под друга таблицата с
// доброволните замени и таблицата с изчертаните площи. Двете имат различни
// колони, но нищо не казва къде свършва едната и започва другата — редовете се
// сливат визуално и се чете грешно.
//
// Надписът е нарочно „шапка на групата", а не заглавие: тънка златна черта
// отгоре и текст в средата, за да разделя, без да утежнява страницата.
export const SectionLabel = ({children, width = "100%"}) => (
    <div className="d-flex justify-content-center mt-4">
        <div style={{
            width,
            borderTop: "2px solid var(--app-gold)",
            paddingTop: "6px",
            textAlign: "center",
            color: "var(--app-gold)",
            fontWeight: 600,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontSize: "0.95rem",
        }}>
            {children}
        </div>
    </div>
);
